/* global Cookiebot */

/**
 * CookieBot manages our consents, see:
 * https://www.cookiebot.com/de/developer/
 */
class CookieConsentManager {
    static getCategoryFromService(service) {
        // See https://manage.cookiebot.com/de/cookies
        const map = {
            google_map: 'necessary',
            youtube: 'marketing',
        };

        return map[service] || 'marketing';
    }

    static showBanner() {
        Cookiebot.show();
    }

    static enable(service) {
        // should never be called, just here for compatibility with other projects
        Cookiebot.show();
        alert('Enable ' + CookieConsentManager.getCategoryFromService(service));
    }

    static hasConsent(service) {
        if (document.body.classList.contains('neos-backend')) {
            // backend and preview mode
            return true;
        }
        if (!Cookiebot?.consent) {
            return false;
        }
        return Cookiebot.consent[CookieConsentManager.getCategoryFromService(service)] || false;
    }

    /*
     * Executes the callback, after we got consent
     */
    static onHasConsent(service, callback) {
        if (CookieConsentManager.hasConsent(service)) {
            callback();
        } else {
            let wasCalled = false;
            window.addEventListener(
                'CookiebotOnConsentReady',
                function () {
                    if (!wasCalled && Cookiebot.consent[CookieConsentManager.getCategoryFromService(service)]) {
                        wasCalled = true;
                        callback();
                    }
                },
                false
            );
            window.addEventListener(
                'CookiebotOnAccept',
                function () {
                    if (!wasCalled && Cookiebot.consent[CookieConsentManager.getCategoryFromService(service)]) {
                        wasCalled = true;
                        callback();
                    }
                },
                false
            );
        }
    }
}

window.CookieConsentManager = CookieConsentManager;
